import React from 'react'
import { Typography, Button } from '@mui/material';
import useStyles from './Styles';

const Pagination = ({currentpage, setPage, totalPages}) => {
    const classes = useStyles();
  

    if (totalPages === 0) 
        return null;
    
    

    const handleNext = () => {
        if (currentpage !== totalPages) {
            setPage((prevpage) =>  prevpage + 1);
        }
    }

    const handlePrev = () => {
        if (currentpage !== 1) {
            setPage((nextpage) => nextpage - 1);
        }
    }
    return (
        <div className={classes.container}>
      <Button onClick={handlePrev} variant="contained" className={classes.button} color="primary" type="button">Prev</Button>
      <Typography variant="h4" className={classes.pageNumber}>{currentpage}</Typography>
      <Button onClick={handleNext} variant="contained" className={classes.button} color="primary" type="button">Next</Button>
    </div>

  )
}

export default Pagination